// extracted by mini-css-extract-plugin
export default {"card":"SectionCard_card__Wzq-d","content":"SectionCard_content__QZE2i","card-image":"SectionCard_card-image__xccW+","desc":"SectionCard_desc__YvdVm"};